// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const ShopOrderAggregatedSourceSourceTypeValues = [
	"SHOP_ORDER_LINE",
	"PROJECT_ACTIVITY_MATERIAL",
	"CUSTOMER_ORDER_LINE",
] as const;

export type ShopOrderAggregatedSourceSourceType = (typeof ShopOrderAggregatedSourceSourceTypeValues)[number];

export const getShopOrderAggregatedSourceSourceTypeLabels = () => ({
	SHOP_ORDER_LINE: t("shop_order_line"),
	PROJECT_ACTIVITY_MATERIAL: t("project_activity_material"),
	CUSTOMER_ORDER_LINE: t("customer_order_line"),
});

export const getShopOrderAggregatedSourceSourceTypeLabel = (value: ShopOrderAggregatedSourceSourceType): string => {
	return getShopOrderAggregatedSourceSourceTypeLabels()[value];
};
